import { render, staticRenderFns } from "./AgentTab.vue?vue&type=template&id=a3696448&scoped=true"
import script from "./AgentTab.vue?vue&type=script&lang=js"
export * from "./AgentTab.vue?vue&type=script&lang=js"
import style0 from "./AgentTab.vue?vue&type=style&index=0&id=a3696448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3696448",
  null
  
)

export default component.exports